/**
 * IdleHistorySection Component
 *
 * Direct wrapper for IdleHistory component (no extra collapse)
 * Maintains existing IdleHistory functionality with its own collapse
 */

import React from "react";
import IdleHistory from "../../ExitFromUserDetails/IdleHistory";

const IdleHistorySection = ({ data }) => {
  return <IdleHistory data={data} />;
};

export default IdleHistorySection;
